import { Component, OnInit } from '@angular/core';
import { CardBloc } from '@kp/shared/components/cards/card.bloc';

@Component({
  selector: 'kp-detail-card-unloader',
  templateUrl: './detail-card-unloader.component.html',
  styleUrls: ['./detail-card-unloader.component.scss'],
})
export class DetailCardUnloaderComponent implements OnInit {
  constructor(public cardBloc: CardBloc) {}

  ngOnInit() {
    this.cardBloc.detailViewClicked.next({ detailViewClicked: false });
  }
}
